/** Caps timeline events in the interest context slice that can carry message body excerpts. */
export const ASSISTANT_INTEREST_EXCERPT_MAX_EVENTS = 8;
